import React from 'react'
import { ModeToggle } from '../mode-toggle'
import Image from 'next/image'
import ArrowAI from '../icons/ArrowAI'

export const TitanFooter = () => {
  return (
    <footer>
      <div className="fixed bottom-0 right-0 w-fit p-1 md:p-2">
        <div className="flex items-center justify-end">
          <div className="mr-2 text-sm text-gray-500">
            <ArrowAI />
          </div>
        </div>
      </div>
    </footer>
  )
}
